import React, { useId, useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Collapsible accordion section for product add/edit forms.
 * Section 1 (alwaysOpen) renders without collapse chrome.
 */
const ProductFormSection = ({
  title,
  description,
  children,
  defaultOpen = false,
  alwaysOpen = false,
  badge,
  className = "",
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const isOpen = alwaysOpen || open;

  if (alwaysOpen) {
    return (
      <section
        className={`product-form-page__section product-form-page__section--static ${className}`.trim()}
      >
        <div className="product-form-page__section-head">
          <h2 className="product-form-page__section-title">{title}</h2>
          {description && (
            <p className="product-form-page__section-desc">{description}</p>
          )}
        </div>
        <div className="product-form-page__section-body">{children}</div>
      </section>
    );
  }

  return (
    <section
      className={`product-form-page__accordion ${isOpen ? "is-open" : ""} ${className}`.trim()}
    >
      <button
        type="button"
        className="product-form-page__accordion-trigger"
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="product-form-page__accordion-trigger-text">
          <span className="product-form-page__accordion-title">{title}</span>
          {description && (
            <span className="product-form-page__accordion-desc">{description}</span>
          )}
        </span>
        <span className="product-form-page__accordion-meta">
          {badge != null && badge > 0 && (
            <span className="product-form-page__accordion-badge">{badge}</span>
          )}
          <ChevronDown
            size={20}
            className="product-form-page__accordion-chevron"
            aria-hidden
          />
        </span>
      </button>
      <div
        id={panelId}
        className="product-form-page__accordion-panel"
        aria-hidden={!isOpen}
      >
        <div className="product-form-page__accordion-body">{children}</div>
      </div>
    </section>
  );
};

export default ProductFormSection;
